<!-- 产品-设备详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div class="md-layout-item md-size-100">
      <!-- 卡片-主体-查询表单 -->
      <div class="md-layout card-form">
        <div class="md-layout md-layout-item md-size-70 md-xsmall-size-100">
          <!-- 表单-输入栏-查询类型 {uid: 查询UID, mac: 查询MAC} -->
          <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
            <md-field>
              <md-select v-model="searchForm.searchType" >
                <md-option value="uid">{{$I18n('search_by_uid')}}</md-option>
                <md-option value="mac">{{$I18n('search_by_mac')}}</md-option>
                <!-- <md-option value="token">{{$I18n('search_by_token')}}</md-option> -->
                <!-- <md-option value="pk">{{$I18n('search_by_pk')}}</md-option> -->
              </md-select>
            </md-field>
          </div>
          <!-- 表单-输入栏-查询参数 (与 searchType 对应) -->
          <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
            <md-field>
              <label v-if="searchForm.searchType === 'uid'">UID</label>
              <label v-if="searchForm.searchType === 'mac'">MAC</label>
              <label v-if="searchForm.searchType === 'token'">TOKEN</label>
              <label v-if="searchForm.searchType === 'pk'">PK</label>
              <md-input v-model="searchForm.searchValue"/>
            </md-field>
          </div>
          <!-- 表单-选择栏-设备状态 {0: 全部, 1: 未激活, 2: 已激活} -->
          <!-- <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
            <md-field>
              <label>{{$I18n("state")}}</label>
              <md-select v-model="searchForm.state">
                <md-option value="0">{{$I18n('all')}}</md-option>
                <md-option value="1">{{$I18n('no_active')}}</md-option>
                <md-option value="2">{{$I18n('is_active')}}</md-option>
              </md-select>
            </md-field>
          </div> -->
          <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
            <md-field>
              <label>{{$I18n("company")}}</label>
              <md-select v-model="searchForm.comp_id">
                <md-option  :value="0" >{{$I18n("all")}}</md-option>

                <md-option v-for="comp in compData" :key  ="comp.comp_id" :value="comp.comp_id">
                  {{comp.comp_name}}
                </md-option>
              </md-select>
              <!-- <md-icon v-if="error.company">clear</md-icon> -->
            </md-field>
          </div>
          <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
          <div class="md-layout-item md-size-50 left-layout-item" v-if="$root.state.mobile" :style="{'padding-right':0}">
            <md-button class= "left-icon md-info right-button md-just-icon" @click="form_changeSearchData">
              <md-icon>search</md-icon>
            </md-button>
          </div>
        </div>
        <!-- 表单-按钮- -->
        <div class="md-layout md-layout-item md-size-30 md-xsmall-size-100">
          <!-- 表单-按钮-重新查询 (只在大屏幕中显示) -->
          <div class="md-layout-item md-size-25" v-if="!$root.state.mobile">
            <md-button class= "left-icon md-info" @click="form_changeSearchData">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
      </div>
      <!-- 卡片-主体-内容表格 
        体系
        所属企业
        UID
        MAC
        IP
        所属区域
        版本
        设备状态 {1: 未激活, 2: 已激活}
        首次激活时间
        最近上线时间
       -->
      <md-table v-model="tableData">
        <md-table-row slot="md-table-row" slot-scope="{ item }" >
          <md-table-cell :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
          <md-table-cell :md-label="'UID'">{{ item.uid }}</md-table-cell>
          <!-- <md-table-cell :md-label="'MAC'">{{ item.mac }}</md-table-cell> -->
          <!-- <md-table-cell :md-label="'IP'">{{ item.ip }}</md-table-cell> -->
          <md-table-cell :md-label="$I18n('zone')">{{ item.zone_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('version')">{{ item.ver }}</md-table-cell>
          <md-table-cell :md-label="$I18n('state')">{{ item.dev_state }}</md-table-cell>
          <md-table-cell :md-label="$I18n('fri_active_time')">{{ item.active_time }}</md-table-cell>
          <md-table-cell :md-label="$I18n('last_online_time')">{{ item.update_time }}</md-table-cell>
        </md-table-row>
        <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
      </md-table>
      <!-- 翻页 -->
      <div :style="{'display': 'flex', 'justify-content': 'flex-end', 'align-items': 'center'}">
        <p :style="{'flex-grow':1}" class="card-category">{{$I18n("total" )}} : {{total}}</p>
        <pagination v-model="currentPage" :per-page="pageSize" :total="total" class="pagination-no-border" type= "info"/>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination } from "@/components";
import { timestampToString1000 } from "@/common/tools.js";

export default {
  components: {
    Pagination,
  },
  props: {
    pk : {
      type: String,
      default: "",
    },
    comps: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      pickerOptions: { // 选择时间插件的配置 
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      modalSearchData : { // 弹窗-表单-检索数据
        state : 0,
        time : [],
      },
      searchForm : { // 表单-表单数据
        searchType : "uid",
        searchValue: "",
        state : "0",
        comp_id: 0,
      },
      searchData : { // 表格-检索数据
        mac : "",
        uid : "",
        state: 0,
      },
      icon  : "computer", // ICON
      title : this.$I18n("device_info"), // 卡片标题
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      openModal: false,  // 是否打开弹窗
      openModalType : "upload", // 弹窗类型
      modalTitle : "",  // 弹窗标题
      // 弹窗表单相关
      modalData : {
        company : "",
        file : "",
        file_url : "",
      },
      // 弹窗表单报错相关
      error: {
        file : false,
      },
      // 弹窗表格数据
      modalTableInitData : [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    modalTableForm(){ // 弹窗-API提交用弹窗表格检索参数
      return {
        state            : this.modalSearchData.state,
        gmt_start: this.modalSearchData.time[0]?parseInt(new Date(this.modalSearchData.time[0]).getTime()/1000) :0,
        gmt_end  : this.modalSearchData.time[1]?parseInt(new Date(this.modalSearchData.time[1]).getTime()/1000) :0,
      }
    },
    modalTableData () { // 弹窗-表格-表格数据(处理后)
      if (!this.modalTableInitData || this.modalTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalTableInitData]
          .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            // 公司
            let company  = this.$I18n("unknow");
            this.comps.forEach(function(com){
                if(com.comp_id == item.comp_id){
                  company = com.comp_short_name ?com.comp_short_name :com.comp_name;
                }
            })
            // 导入状态
            let import_state = this.$I18n("unknow");
            if(item.state== 1){
              import_state = this.$I18n("has_sync_database");
            }else if(item.state == 4){
              import_state = this.$I18n("wait_sync_database");
            }else if(item.state == 2 ){
              import_state = this.$I18n("has_error_row");
            } else if( item.state == 3){
              import_state = this.$I18n("file_error");
            } else if ( item.state == 5){
              import_state = this.$I18n("is_sync_database")
            }
            // 3个参数(确保是数字)
            item.mng_num =  isNaN(item.mng_num )  ?0 :item.mng_num ;
            item.succ_num = isNaN(item.succ_num ) ?0 :item.succ_num;
            item.fail_num = isNaN(item.fail_num ) ?0 :item.fail_num;
            return {
              company,
              import_state,
              ... item,
            }
          })
      }
    },
    tableData(){ // 表格-展示数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 公司
          let company  = this.$I18n("unknow");
          this.comps.forEach(function(com){
              if(com.comp_id == item.comp_id){
                company = com.comp_short_name ?com.comp_short_name :com.comp_name;
              }
          })
          // 状态
          let dev_state = "";//this.$I18n('unknown')
          switch(item.state){
            case "1":
            case 1:
              dev_state = this.$I18n("no_active");
              break;
            case "0":
            case 0:
            default:
              dev_state = this.$I18n("is_active");
              break;
          }
          // 区域名称
          let zone_name = this.$I18n("unknow");
          if (item.zone){
            zone_name = this.$I18n(item.zone);
          }
          return {
            active_time : item.gmt_create ?timestampToString1000(item.gmt_create) :"",
            update_time : item.gmt_update ?timestampToString1000(item.gmt_update) :"",
            dev_state,
            company,
            zone_name,
            ... item,
          }
        })
      }
    },
  },
  methods: {
    modal_changeSearchData(){ // 弹窗-重新查询弹窗内表格数据
      this.api_getXlsxData();
    },
    modal_file_input(){ // 点击上传文件
      this.$refs.inputFile.click()
    },
    onChange ($event) { // (file发生变化)
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) { // 选择文件
      const files = target.files || dataTransfer.files;
      if(files[0].type.includes(".sheet")){
        this.modalData.file = this.getFileName(files, target);
      } else {
        this.$errorMsg(this.$I18n("need_xlsx"))
      }
    },
    getFileName (files, target) { // 获取文件名
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        this.modalData.file_url = ""
        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.modalData.file_url = res.data;
          }))
          .catch(this.$Catch(this.$I18n("file_error"),() => {
            this.modalData.file = "";
          }))
        return files[0].name
      }

      return null
    },
    api_getXlsxData (){ // API-提交xls文件数据
      this.$api.getDevListXlsx(this.modalTableForm)
        .then(this.$Then(resData => {
          this.modalTableInitData = resData.data.map(i => {
            return {
              ...i,
              import_id: i.id,
            }
          });
          this.import_total = resData.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableInitData = [];
          this.import_total = 0;
        }))
    },
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.queryIotReg({ // api: /iot/uid/reg/query
          ...this.searchData,
          pk: this.pk,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data.map(item => {
            if(!item.ver){
              item.ver = "";
            }
            return item;
          })
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    form_changeSearchData () { // 表单-更改查询条件(并立刻查询)
      this.searchData = {
        mac : this.searchForm.searchType === "mac" ?this.searchForm.searchValue :"",
        uid : this.searchForm.searchType === "uid" ?this.searchForm.searchValue :"",
        token : this.searchForm.searchType === "token" ?this.searchForm.searchValue :"",
        pk : this.pk,
        state: parseInt(this.searchForm.state),
        comp_id: parseInt(this.searchForm.comp_id),
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
    form_importModel () { // 表单-打开 导入xlsx弹窗
      this.openModalType = "update";
      this.modalTitle = this.$I18n("import_and_update");
      if (this.comps.length === 0){
        this.$errorMsg(this.$I18n("unknown_error"))
        return;
      }
      this.modalData = {
        company  : this.UserInfo.comp_id,
        file     : "",
        file_url : "",
      };
      this.openModal = true;
    },
    form_importTableModel () { // 表单-打开导入弹窗
      this.api_getXlsxData();
      this.openModalType = "import";
      this.modalTitle = this.$I18n("dev_import");
      this.openModal = true;
    },
    modal_classicModalHide () { // 弹窗-隐藏 弹窗
      this.openModal = false;
      this.error.file = false;
    },
    modal_submit () { // 弹窗-提交表单
      var compItem = this.comps.filter(comp => {
        return comp.comp_id == this.modalData.company;
      })[0]
      if(!compItem){
        this.$errorMsg(this.$I18n("unknown_error"))
        return 
      }
      if(!this.modalData.file_url){
        this.error.file = true;
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return 
      }
      this.$api.uploadDevOrder({ // api: /iot/dev/file/update
          file_url: this.modalData.file_url,
          comp_id: this.modalData.company,
          sys: compItem.sys,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
